import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { Roles } from "~enums/roles";
import { useAddRole } from "~hooks/apiHooks/useAddRole";
import { useApi } from "~hooks/apiHooks/useApi";
import type { UpsertSeasonRosterModel } from "~pages/Roster/SeasonRosterListPage/types/upsertSeasonRosterModel";
import type { Roster, RosterResponse } from "~types/roster";

const useUpsertSeasonRosterPlayer = () => {
  const { sport, organizationId, seasonId } = useParams();
  const request = useApi();
  const queryClient = useQueryClient();

  const { mutateAsync: createCaptainRole } = useAddRole();
  return useMutation<RosterResponse, Error, UpsertSeasonRosterModel>({
    mutationFn: async (upsertModel: UpsertSeasonRosterModel) => {
      const url = `${sport}/o/${organizationId}/seasons/${seasonId}/roster`;
      const method = "POST";
      const body = { ...upsertModel, isCaptain: undefined };
      return await request(url, { method, body });
    },
    onSuccess: async (response: { data: Array<Roster> }, upsertModel) => {
      if (response?.data && response.data.length > 0) {
        if (upsertModel.isCaptain && seasonId) {
          await createCaptainRole({
            personId: upsertModel.personId,
            entityId: upsertModel.entityId,
            seasonId,
            role: Roles.Captain,
          });
        }
        await queryClient.invalidateQueries({
          queryKey: ["seasonRoster", sport, organizationId, seasonId],
        });
        await queryClient.invalidateQueries({
          queryKey: ["seasonRosterShort", sport, organizationId, seasonId],
        });
      }
    },
  });
};

export default useUpsertSeasonRosterPlayer;
